export default {
    declarations: {
        project_manager: {
            index: 'Maître d\'oeuvre (chargé du chantier de brûlage)',
        },
    },
}
